var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import * as SavvyResultsUI from "../components/SavvyResultsUI/SavvyResultsUI";
import { ImpressionType, NOT_INSURED_ISSUER_SLUG } from "../lib/constants";
import Ad from "../components/Ad/Ad";
import { AllIssuers } from "@trellisconnect/types/dist/src/enums/AllIssuers";
import Header from "../components/Header";
import IncentivizedBanner from "../components/IncentivizedBanner";
import { InsuranceType } from "../constants";
import { LoadingCircle } from "../components/LoadingIcon";
import NoAdsFound from "../components/NoAdsFound";
import { QueryStatus } from "@reduxjs/toolkit/query";
import { sawImpression } from "../lib/Avo";
import useAccountReferenceId from "../services/savvy/useAccountReferenceId";
import useAppSelector from "../hooks/useAppSelector";
import { useEffectOnceWhen } from "rooks";
import useSearchResults from "../services/savvy/useSearchResults";
function Loading() {
    return (React.createElement("div", { id: "midfunnelads_loading", className: "m-auto w-[50px]" },
        React.createElement(LoadingCircle, null)));
}
function MidFunnelAdsList(_a) {
    var ads = _a.ads, impressionId = _a.impressionId;
    if (ads.length === 0) {
        return React.createElement(NoAdsFound, null);
    }
    return (React.createElement(SavvyResultsUI.List, { className: "ads" }, ads.map(function (ad, index) {
        return (React.createElement(SavvyResultsUI.ListItem, { key: "".concat(ad.id, "-").concat(index) },
            React.createElement(Ad, { ad: ad, index: index, impressionId: impressionId })));
    })));
}
function getSecondaryText(_a) {
    var selectedIssuer = _a.selectedIssuer, name = _a.name;
    if (!(selectedIssuer === null || selectedIssuer === void 0 ? void 0 : selectedIssuer.id) || selectedIssuer.id === AllIssuers.OTHER) {
        return name || "Unknown";
    }
    return selectedIssuer.id === NOT_INSURED_ISSUER_SLUG ? undefined : name;
}
export default function MidFunnelAdsRoute() {
    var _a = useAppSelector(function (state) {
        var _a = state.applicant, currentIssuer = _a.currentIssuer, accountLinked = _a.accountLinked;
        return {
            selectedIssuer: currentIssuer.auto || currentIssuer.home,
            accountLinked: accountLinked.auto || accountLinked.home,
        };
    }), selectedIssuer = _a.selectedIssuer, accountLinked = _a.accountLinked;
    var _b = useAppSelector(function (_a) {
        var unlinkedApplication = _a.unlinkedApplication;
        var _b = unlinkedApplication.policyHolder, firstName = _b.firstName, lastName = _b.lastName;
        return {
            numOfDrivers: unlinkedApplication.auto.drivers.length,
            numOfVehicles: unlinkedApplication.auto.vehicles.length,
            firstName: firstName,
            lastName: lastName,
        };
    }), numOfDrivers = _b.numOfDrivers, numOfVehicles = _b.numOfVehicles, firstName = _b.firstName, lastName = _b.lastName;
    var _c = useSearchResults({
        impressionTypeOverride: ImpressionType.OnboardAbandon,
    }), _d = _c.searchQuery, searchResults = _d.data, isLoading = _d.isLoading, isSuccess = _d.isSuccess, postUnlinkedAccountStatus = _c.postUnlinkedAccountStatus;
    var accountReferenceIdStatus = useAccountReferenceId().status;
    var enableFormExperience = useAppSelector(function (state) { return state.configuration.enableFormExperience; });
    var commonAnalyticsProperties = useAppSelector(function (state) { return state.analytics.commonAnalyticsProperties; });
    var secondaryText = getSecondaryText({
        selectedIssuer: selectedIssuer,
        name: firstName || lastName ? "".concat(firstName, " ").concat(lastName) : undefined,
    });
    useEffectOnceWhen(function () {
        sawImpression(__assign(__assign({}, commonAnalyticsProperties), { impressionRequest: {
                hasLinkedAccount: accountLinked,
                insuranceType: "auto",
                forceFormat: "",
                medium: "online",
            }, impression: {
                insuranceType: "auto",
                format: "",
                searchedProductTypes: [],
            } }));
    });
    return (React.createElement(React.Fragment, null,
        React.createElement(Header, null,
            React.createElement("h2", { className: "w-full text-center text-base font-bold leading-4 text-black-100" }, "Savvy Auto Offers")),
        React.createElement(SavvyResultsUI.Root, null,
            React.createElement(SavvyResultsUI.Header, { currentIssuerName: selectedIssuer === null || selectedIssuer === void 0 ? void 0 : selectedIssuer.name, currentIssuerId: selectedIssuer === null || selectedIssuer === void 0 ? void 0 : selectedIssuer.id, numOfDrivers: numOfDrivers, numOfVehicles: numOfVehicles, secondaryText: secondaryText, firstName: firstName, lastName: lastName, insuranceType: InsuranceType.Auto }),
            React.createElement(SavvyResultsUI.Body, { beforeContent: !enableFormExperience ? (React.createElement(IncentivizedBanner, { className: "mb-4" })) : null },
                accountReferenceIdStatus === QueryStatus.pending ||
                    isLoading ||
                    postUnlinkedAccountStatus.isLoading ? (React.createElement(Loading, null)) : null,
                isSuccess && searchResults ? (React.createElement(MidFunnelAdsList, { ads: searchResults.ads, impressionId: searchResults.impressionId })) : null))));
}
